<vdr-rich-text-editor
  [readonly]="readonly"
  [formControl]="formControl"
></vdr-rich-text-editor>
